import React, { useEffect, useMemo } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { MODAL_IDS } from '../../store/ui/ui.constants'
import { withOnlyGE } from '../Device'
import Modal from '../genericComponents/Modal'
import cross from '../genericComponents/assets/cross.svg'
import { withFrenchSite } from '../i18n/i18nSite'
import SVGIcon from '../svg/SVGIcon'
import useModal from '../ui/useModal'
import { ONE_SECOND_MS } from '../utils/date'
import useEventCallback from '../utils/useEventCallback'
import s from './PoisOnRouteIncentivePopin.less'
import { setPoisOnRouteIncentivePopin } from '../../store/incentive/incentiveSlice'
import { selectShouldDisplayPoisOnRouteIncentivePopin } from '../../store/incentive/incentive.selectors'

const getModalStyle = () => {
  return {
    top: 70,
    left: window.innerWidth / 2,
    transform: 'none',
    margin: 0
  }
}

const PoisOnRouteIncentive = () => {
  const dispatch = useDispatch()
  const shouldDisplay = useSelector(selectShouldDisplayPoisOnRouteIncentivePopin)
  const { displayModal, hideModal } = useModal(MODAL_IDS.POIS_ON_ROUTE_INCENTIVE_POPIN)
  const modalStyle = useMemo(() => getModalStyle(), [])

  useEffect(() => {
    let popinDisplayTimeout

    if (shouldDisplay) {
      popinDisplayTimeout = setTimeout(() => {
        displayModal()
        dispatch(setPoisOnRouteIncentivePopin())
      }, ONE_SECOND_MS * 3)
    }

    return () => clearTimeout(popinDisplayTimeout)
  }, [shouldDisplay])

  const onCloseClick = useEventCallback(() => {
    hideModal()
  })

  return (
    <Modal id="poisOnRouteModal" modalId={MODAL_IDS.POIS_ON_ROUTE_INCENTIVE_POPIN} style={modalStyle}>
      <div className={s.root}>
        <div className={s.title}>Le saviez-vous ?</div>
        <div className={s.form}>Utilisez nos catégories pour rechercher un lieu sur votre itinéraire.</div>
      </div>
      <div className={s.closeBtn} onClick={onCloseClick}>
        <SVGIcon url={cross} />
      </div>
    </Modal>
  )
}

export default withFrenchSite(withOnlyGE(PoisOnRouteIncentive))
